import * as Yup from 'yup';
import { SurveyFormValues } from './SurveyFormValues';

export const surveyValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Le nom est requis')
    .max(255, 'Le nom ne peut pas dépasser 255 caractères'),
  code: Yup.string()
    .required('Le code est requis')
    .max(10, 'Le code ne peut pas dépasser 10 caractères'),
  description: Yup.string()
    .max(1000, 'La description ne peut pas dépasser 1000 caractères'),
  contextId: Yup.string()
    .required('Le contexte est requis'),
  branchId: Yup.string()
    .nullable(),
  isActive: Yup.boolean()
});

export const surveyInitialValues: SurveyFormValues = {
  name: '',
  code: '',
  description: '',
  contextId: '',
  branchId: '',
  isActive: true
};

export const surveyFormConfig = {
  initialValues: surveyInitialValues,
  validationSchema: surveyValidationSchema
};
